<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key" i18n="@@common.country">Country:</span>
          <span class="value">
            <gtd-ui-field-default-country [data]="data.conversion.country"></gtd-ui-field-default-country>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.offer">Offer:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/traffic-control/offers', data.conversion?.offer?.id]"
              [displayData]="data.conversion?.offer?.name"
              [relationData]="data.conversion?.offer?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_OFFER_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.affiliate">Affiliate:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/affiliates/affiliates', data.conversion?.affiliate?.id]"
              [displayData]="data.conversion?.affiliate?.name"
              [relationData]="data.conversion?.affiliate?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.click">Click:</span>
          <span class="value">
            <gtd-ui-field-default-link
              [link]="['/app/traffic-data/clicks', data.conversion?.click_id]"
              [displayData]="data.conversion?.click_id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_CLICK_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.goal">Goal:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/settings/crm-offer-goals', data.conversion?.goal?.id]"
              [displayData]="data.conversion?.goal?.name"
              [relationData]="data.conversion?.goal?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_GOAL_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.payout">Payout:</span>
          <span class="value">
            <gtd-ui-field-default-money
              [data]="data.conversion?.payout"
              [currencyCode]="data.conversion?.currency_code"
            ></gtd-ui-field-default-money>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.revenue">Revenue:</span>
          <span class="value">
            <gtd-ui-field-default-money
              [data]="data.conversion?.revenue"
              [currencyCode]="data.conversion?.currency_code"
            ></gtd-ui-field-default-money>
          </span>
        </p>
      </li>
      <li *ngIf="isVisibleApproved">
        <p>
          <span class="key" i18n="@@common.approve">Approve:</span>
          <span class="value">
            <gtd-ui-field-default-boolean [data]="data.conversion?.is_approved"></gtd-ui-field-default-boolean>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.qualified">Qualified:</span>
          <span class="value">
            <gtd-ui-field-default-boolean [data]="data.conversion?.satisfied"></gtd-ui-field-default-boolean>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.additional">Additional</li>
      <li>
        <p>
          <span class="key" i18n="@@common.payout_model">Payout Model:</span>
          <span class="value cut-overflow">
            <gtd-ui-field-default-link
              [link]="['/app/settings/crm-payout-models', data.conversion?.payout_model?.id]"
              [displayData]="data.conversion?.payout_model?.name"
              [relationData]="data.conversion?.payout_model?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_PAYOUT_BUSINESS_MODEL"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.revenue_model">Revenue Model:</span>
          <span class="value">
            <gtd-ui-field-default-link
              [link]="['/app/settings/crm-revenue-models', data.conversion?.revenue_model?.id]"
              [displayData]="data.conversion?.revenue_model?.name"
              [relationData]="data.conversion?.revenue_model?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_REVENUE_BUSINESS_MODEL"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.timestamps">Timestamps</li>
      <li>
        <p>
          <span class="key" i18n="@@common.created_at">Created At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.conversion.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key" i18n="@@common.updated_at">Updated At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.conversion.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
